import { UserState, ActionTypes, Action } from './types';

const INITIAL_STATE: UserState = {
  error: false,
  loading: false,
  token: '',
  user: {
    id: 0,
    email: '',
    first_name: '',
    last_name: '',
    name: '',
  },
};

export default function reducer(state = INITIAL_STATE, action: Action): UserState {
  switch (action.type) {
    case ActionTypes.RESET_STATE:
      return {
        error: false,
        loading: false,
        token: INITIAL_STATE.token,
        user: INITIAL_STATE.user,
      };

    case ActionTypes.AUTHENTICATION:
      return {
        ...INITIAL_STATE,
        error: false,
        loading: true,
        token: '',
      };

    case ActionTypes.AUTHENTICATION_SUCCESS:
      return {
        error: false,
        loading: false,
        token: action.token,
        user: action.user,
      };

    case ActionTypes.AUTHENTICATION_ERROR:
      return {
        ...INITIAL_STATE,
        error: true,
        loading: false,
        token: '',
      };

    case ActionTypes.DEFINE_USER:
      return {
        ...INITIAL_STATE,
        token: action.token,
        user: action.user,
      };

    case ActionTypes.REMOVE_USER:
      return {
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
}
